import create from 'utilities/zustand/create';
import { getGPUTier } from 'detect-gpu';

export const useDebugAssetVersion = create(set => ({
  version: 0,
}));
